import EN from './en.jpg'
import HK from './hk.jpg'
import ID from './id.jpg'
import TH from './th.jpg'
import VI from './vi.jpg'
import store from '@/store'
import { computed } from 'vue'

// 头图为 2048×1152 的整张 KV（logo 与标题已烘在图内），按语言分别出图
const langToImgMap = {
  en: EN,
  sg: EN,
  my: EN,
  ph: EN,
  hk: HK,
  tw: HK,
  id: ID,
  th: TH,
  vi: VI,
}

export default computed(() => langToImgMap[store.state.locale])
